import React, { useState } from "react";
import { Box, Flex, Text, IconButton } from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon, CloseIcon } from "@chakra-ui/icons";

const PlaceholdersModal = ({
  textAreaRef,
  setCustomizedTemplate,
  customizedTemplate,
  placeholders,
  templatePath,
  campaignMedium,
  onClose,
  isCollapsible
}) => {
  const [isExtended, setIsExtended] = useState(true);

  const toggleModalSize = () => {
    setIsExtended(!isExtended);
  };

  return (
    <Box p={4} width="100%" height="auto" overflowY="auto">
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontSize="xl" fontWeight="bold">Placeholders</Text>
        {isCollapsible && (
          <IconButton
            icon={isExtended ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={toggleModalSize}
            aria-label={isExtended ? "Collapse" : "Extend"}
            variant="ghost"
            size="sm"
          />
        )}
        {!isCollapsible && (
          <IconButton
            icon={<CloseIcon />}
            onClick={onClose}
            aria-label="Close without saving"
            variant="ghost"
            size="sm"
          />
        )}
      </Flex>
      {isExtended && (
        <Box textAlign="left">
          {placeholders.map((ph, index) => (
            <Box
              key={index}
              p={2}
              borderBottom="1px solid"
              borderColor="gray.200"
              cursor="pointer"
              _hover={{ backgroundColor: "gray.100" }}
              onMouseDown={(e) => {
                e.preventDefault(); // Prevent the default behavior
                if (campaignMedium === "Email") {
                  return;
                }
                const textarea = textAreaRef.current;
                const start = textarea.selectionStart;
                const end = textarea.selectionEnd;
                const text = templatePath.reduce((obj, key) => obj && obj[key], customizedTemplate) || "";
                const before = text.substring(0, start);
                const after = text.substring(end, text.length);
                const newText = before + ph.placeholder + after;

                setCustomizedTemplate((prevTemplate) => {
                  let updatedTemplate = { ...prevTemplate };
                  let target = updatedTemplate;
                  for (let i = 0; i < templatePath.length - 1; i++) {
                    target = target[templatePath[i]];
                  }
                  target[templatePath[templatePath.length - 1]] = newText;
                  return updatedTemplate;
                });

                setTimeout(() => {
                  textarea.focus();
                  textarea.selectionStart = start + ph.placeholder.length;
                  textarea.selectionEnd = start + ph.placeholder.length;
                }, 0);
              }}
            >
              <Text fontWeight="bold">{ph.placeholder}</Text>
              <Text>{ph.meaning}</Text>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PlaceholdersModal;
